import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import store from 'store';

import App from './components/App';
import ErrorBoundary from './components/shared/ErrorBoundary';
import { GlobalStyle } from './styles/global';

const container = document.getElementById('root');

if (container) {
  ReactDOM.render(
    <Provider store={store}>
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
      <GlobalStyle />
    </Provider>,
    container,
  );
}
